import type { RadioAdSpaces } from '@/pages/sa/ad-spaces/types';

export const adSpacesRadios: RadioAdSpaces[] = [
  {
    id: 1,
    radioName: 'Radio Éxito',
    radioFrequency: '98.5 FM',
    radioCity: 'Madrid',
    plan: 'Premium',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: true },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: true },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: false },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: true },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: true },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: true },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: false },
    ],
    lastUpdated: '2026-06-16',
  },
  {
    id: 2,
    radioName: 'La Nueva FM',
    radioFrequency: '104.3 FM',
    radioCity: 'Barcelona',
    plan: 'Premium',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: true },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: true },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: true },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: true },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: false },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: true },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: true },
    ],
    lastUpdated: '2026-06-16',
  },
  {
    id: 3,
    radioName: 'Radio Caliente',
    radioFrequency: '91.7 FM',
    radioCity: 'Sevilla',
    plan: 'Estándar',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: false },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: true },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: false },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: false },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: true },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: false },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: false },
    ],
    lastUpdated: '2026-06-15',
  },
  {
    id: 4,
    radioName: 'Voz del Pueblo',
    radioFrequency: '107.1 FM',
    radioCity: 'Valencia',
    plan: 'Premium',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: true },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: true },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: true },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: true },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: true },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: true },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: true },
    ],
    lastUpdated: '2026-06-16',
  },
  {
    id: 5,
    radioName: 'Onda Digital',
    radioFrequency: '96.2 FM',
    radioCity: 'Bilbao',
    plan: 'Estándar',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: true },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: false },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: false },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: false },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: true },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: false },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: false },
    ],
    lastUpdated: '2026-06-14',
  },
  {
    id: 6,
    radioName: 'Radio Sol',
    radioFrequency: '102.8 FM',
    radioCity: 'Málaga',
    plan: 'Premium',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: false },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: false },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: false },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: false },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: false },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: false },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: false },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: false },
    ],
    lastUpdated: '—',
  },
  {
    id: 7,
    radioName: 'FM Latina',
    radioFrequency: '95.1 FM',
    radioCity: 'Zaragoza',
    plan: 'Estándar',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: false },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: true },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: true },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: false },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: true },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: false },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: true },
    ],
    lastUpdated: '2026-06-15',
  },
  {
    id: 8,
    radioName: 'Radio Mar',
    radioFrequency: '89.4 FM',
    radioCity: 'A Coruña',
    plan: 'Básico',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: false },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: false },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: false },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: false },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: false },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: false },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: false },
    ],
    lastUpdated: '2026-06-16',
  },
  {
    id: 9,
    radioName: 'Estéreo Norte',
    radioFrequency: '101.5 FM',
    radioCity: 'Santander',
    plan: 'Estándar',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: true },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: true },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: false },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: false },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: false },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: false },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: false },
    ],
    lastUpdated: '—',
  },
  {
    id: 10,
    radioName: 'Radio Capital',
    radioFrequency: '93.9 FM',
    radioCity: 'Madrid',
    plan: 'Premium',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: true },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: true },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: true },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: true },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: true },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: true },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: true },
    ],
    lastUpdated: '2026-06-16',
  },
  {
    id: 11,
    radioName: 'Urbana Radio',
    radioFrequency: '106.7 FM',
    radioCity: 'Granada',
    plan: 'Básico',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: true },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: false },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: false },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: false },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: false },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: false },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: false },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: false },
    ],
    lastUpdated: '2026-06-14',
  },
  {
    id: 12,
    radioName: 'Radio Tropical',
    radioFrequency: '88.3 FM',
    radioCity: 'Las Palmas',
    plan: 'Estándar',
    spaces: [
      { id: 'banner-principal', name: 'Banner Principal', icon: 'ri-image-line', available: false },
      { id: 'banner-secundario', name: 'Banner Secundario', icon: 'ri-image-2-line', available: false },
      { id: 'patrocinador-principal', name: 'Patrocinador Principal', icon: 'ri-medal-line', available: false },
      { id: 'patrocinador-evento', name: 'Patrocinador Evento', icon: 'ri-calendar-event-line', available: false },
      { id: 'patrocinador-concurso', name: 'Patrocinador Concurso', icon: 'ri-trophy-line', available: false },
      { id: 'publicacion-patrocinada', name: 'Publicación Patrocinada', icon: 'ri-file-text-line', available: false },
      { id: 'programa-patrocinado', name: 'Programa Patrocinado', icon: 'ri-mic-line', available: false },
      { id: 'locutor-patrocinado', name: 'Locutor Patrocinado', icon: 'ri-user-voice-line', available: false },
    ],
    lastUpdated: '—',
  },
];